import { CalendarView } from "./view/CalendarView";
import { BookingCtrl } from "./BookingCtrl";
import { CalendarData } from "./model/CalendarData";
import { NavigationView } from "./view/NavigationView";
import { BookingData } from "./model/BookingData";
import { IBookingItem } from "./model/BookingData";
import { IBookingOptions } from "./model/BookingData";
import { BookingHandler } from "./model/BookingHandler";
import { FormView } from "./view/FormView";
import { Day } from "./model/Consts";

const defaultOptions: IBookingOptions =
{
	locale: "hu-HU",
	dayIds: [Day.Monday, Day.Tuesday, Day.Wednesday, Day.Thursday, Day.Friday, Day.Saturday, Day.Sunday]
};

export class BookingManager
{
	constructor(id: string, bookedData: IBookingItem[] = [], partialOptions: IBookingOptions = {})
	{
		const options: IBookingOptions = { ...defaultOptions, ...partialOptions};

		const calendarData = new CalendarData();
		const bookingData = new BookingData(bookedData);
		const bookingHandler = new BookingHandler(bookingData);

		const element = document.getElementById(id);

		const navView = new NavigationView(element);

		const calendar1 = new CalendarView(element, 0, options);
		const calendar2 = new CalendarView(element, 1, options);

		const formView = new FormView(element, options);

		new BookingCtrl(calendarData, bookingData, bookingHandler, navView, calendar1, calendar2, formView);
	}
}
